import React from 'react';
import Anime from 'react-anime';
import logo from '../assets/photos/novartis_logo_pos_rgb.png';
import './LastSlide.scss';
export default ({ isActive }) => {
  const message = 'Interested in participating in a clinical trial? We invite people from around the world to visit the Novartis website to learn more.';
  const slideBall = {
    top: [
      { value: '-100vh', duration: 0 },
      { value: '50vh', duration: 3000, easing: 'easeOutSine' },
    ]
  };

  return (
    <div className="last-slide">

      <div className="content">
        <img src={logo} className="logo" alt="Novartis logo" />
        <div style={{flexDirection: 'column'}} className="text-container">
          <p className="secondary-large centered text-box">{message}</p>
        </div>
          <a className="phase-cta" href={`https://www.novartis.com/clinicaltrials?utm_source=cnn&utm_medium=infographic&utm_campaign=2020-11-clinical-trials-cnn&utm_content=end-learn-link`} rel="noopener noreferrer" target="_blank">Learn More</a>
      </div>

      <div className="pipe-container">
        <div className="pipe">
          <div className="pipe-inner"></div>
          <div className="pipe-cap"></div>
          {isActive && (
            <Anime {...slideBall} className="ball">
              <div></div>
            </Anime>
          )}
        </div>
        <div className="link">
          <a href={`https://www.novartis.com/clinicaltrials?utm_source=cnn&utm_medium=infographic&utm_campaign=2020-11-clinical-trials-cnn&utm_content=end-url-link`} rel="noopener noreferrer" target="_blank">Visit novartis.com/clinicaltrials</a>
        </div>
      </div>

    </div>
  );
}